import Vue from 'vue';
import Vuex from 'vuex';

import auth from '@/store/auth';
import cotacao from '@/store/cotacao';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    cotacao,
  },
});
